module.exports = __webpack_public_path__ + "img/p-huiyou.f0a5332d.png";